export const state = {
	threads: []
}



// WEBPACK FOOTER //
// ./src/store/modules/Office/state.js